import { SplitButton, SplitButtonItem } from "@progress/kendo-react-buttons";
import { Loader } from '@progress/kendo-react-indicators';


interface ItemModel {
    id?: number
    name: string
    icon?: number
    iconClass?: string | any
    itemCssClass?: string | any
    removeBorderPadding?: boolean
}

interface propsModel {
    items: ItemModel[],
    text?: string,
    onChange: any,
    size?: string | any,
    disabled?: boolean
    loading?: boolean
    removeBorderPadding?: boolean
}



function CustomSplitButton({ items, text, onChange, size, disabled, loading, removeBorderPadding }: propsModel) {

    const handleOpen = () => {
        setTimeout(() => {
            const popupItems = document.querySelectorAll('.k-popup .k-item');
            items?.forEach((item, index) => {
                if (item.itemCssClass && popupItems[index]) {
                    popupItems[index].classList.add(...item.itemCssClass.split(' ').filter(Boolean));
                }
            });
        }, 0);
    };

    return (
        <div className="example-col">
            {!loading ? <SplitButton text={text} onItemClick={onChange} onOpen={handleOpen} size={size} className= {removeBorderPadding ? "custom-three-dots" : 'cancelBtn m-0'} disabled={disabled}>
                {
                    items?.map((item) => (
                        <SplitButtonItem key={item.id} text={item.name} iconClass={item?.iconClass} />

                    ))
                }
            </SplitButton> : <Loader style={{ marginLeft: "10px" }} />}
        </div>
    )
}

export default CustomSplitButton